import React from 'react';

import { faAbacus } from '@fortawesome/pro-regular-svg-icons/faAbacus';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  Container,
  Grid2 as Grid,
  IconButton,
  Link,
  Typography,
} from '@mui/material';

export const Mu = () => {
  return (
    <Container maxWidth="md">
      <Box p={2}>
        <Typography gutterBottom variant="h1">
          Heading
        </Typography>
        <Typography gutterBottom variant="h2">
          Title Large
        </Typography>
        <Typography gutterBottom variant="h3">
          Title Small
        </Typography>

        <Typography gutterBottom variant="body1">
          Body Bold
        </Typography>
        <Typography gutterBottom variant="body2">
          Body
        </Typography>

        <Typography gutterBottom variant="subtitle1">
          Small Bold
        </Typography>
        <Typography gutterBottom variant="subtitle2">
          Small
        </Typography>
        <Typography gutterBottom variant="subtitle2" color="textSecondary">
          Label
        </Typography>

        <Typography gutterBottom variant="overline">
          Section
        </Typography>
      </Box>

      <Box p={2}>
        <Grid container spacing={2}>
          <Grid spacing={{ xs: 3 }}>
            <Button variant="outlined" disableElevation>
              <Typography variant="subtitle2" color="textSecondary">
                Cancel
              </Typography>
            </Button>
          </Grid>
          <Grid spacing={{ xs: 3 }}>
            <Button color="primary" variant="contained" disableElevation>
              <Typography variant="subtitle1">Confirm</Typography>
            </Button>
          </Grid>
          <Grid spacing={{ xs: 7 }}>
            <Button
              color="primary"
              variant="contained"
              disableElevation
              fullWidth
            >
              <Box p={2}>
                <Typography variant="subtitle1">Confirm</Typography>
              </Box>
            </Button>
          </Grid>
          <Grid spacing={{ xs: 7 }}>
            <Button
              color="primary"
              variant="contained"
              disableElevation
              fullWidth
              disableRipple
            >
              <Box p={2}>
                <Typography variant="subtitle1">
                  Ripple effect on click can be disabled
                </Typography>
              </Box>
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box p={2}>
        <IconButton size="small">
          <FontAwesomeIcon icon={faStethoscope} />
        </IconButton>
        <IconButton>
          <FontAwesomeIcon icon={faAbacus} />
        </IconButton>

        <Typography variant="body2">
          <Link href="https://fontawesome.com/icons/abacus?style=solid">
            Abacus
          </Link>{' '}
          is a pro icon
        </Typography>
      </Box>
    </Container>
  );
};
